// extracted by mini-css-extract-plugin
var _1 = "GroupChildCard-module__animatedBackground--UVVke";
var _2 = "GroupChildCard-module__avatarsContainer--epjLW";
var _3 = "GroupChildCard-module__badgeContainer--kL9Pf";
var _4 = "GroupChildCard-module__card--QxyQc";
var _5 = "GroupChildCard-module__content--Lc5cx";
var _6 = "GroupChildCard-module__description--XjWmM";
var _7 = "GroupChildCard-module__menuContainer--CONjQ";
var _8 = "GroupChildCard-module__open--OSIQ9";
var _9 = "GroupChildCard-module__overflowButton--mGd6O";
var _a = "GroupChildCard-module__title--O2v9Q";
export { _1 as "animatedBackground", _2 as "avatarsContainer", _3 as "badgeContainer", _4 as "card", _5 as "content", _6 as "description", _7 as "menuContainer", _8 as "open", _9 as "overflowButton", _a as "title" }
